import { useLingui } from "@lingui/react/macro";

import { FareCode } from "@silversea-ssc/web-fares";
import React from "react";
import {
  BlockContentValue,
  FareCardBase,
  FareCardBaseContent,
  FareCardBaseProps,
  FareCardFooterProps,
  FareCardHeader,
  isBlockContentValuePresent
} from "@silversea-ssc/ui-components-react";
import { InclusionCode } from "@silversea-ssc/web-inclusions";
import FareCardInfographic from "./FareCardInfographic";
import { maybeShowFooterNotesForNonAirCountries } from "./utils";
import { useGeolocation } from "src/utils/localization/geolocation/GeolocationContext";
import { BlockContent } from "components/BlockContent";
import MiniFareCardFooterDisclaimer from "./MiniFareCardFooterDisclaimer";

type MiniFareCardProps = Omit<FareCardBaseProps, "trackingName"> & {
  title: string | undefined;
  headline: string | undefined;
  description: string | undefined;
  fareCode: FareCode;
  ctaButton?: FareCardFooterProps["ctaButton"];
  enabledInclusions: readonly InclusionCode[];
  hilighted?: boolean;
  footerNotesForNonAirCountries?: BlockContentValue;
};

const MiniFareCard: React.FC<MiniFareCardProps> = ({
  title,
  headline,
  description,
  fareCode,
  enabledInclusions,
  ctaButton,
  hilighted = false,
  footerNotesForNonAirCountries,
  ...otherProps
}) => {
  const { t } = useLingui();
  const geolocation = useGeolocation();
  const maybeFooterNotesForNonAirCountries =
    maybeShowFooterNotesForNonAirCountries(
      geolocation.airCountry,
      footerNotesForNonAirCountries
    );

  return (
    <React.Fragment>
      <FareCardBase
        trackingName={`infographic_${fareCode}`}
        hilighted={hilighted}
        {...otherProps}
      >
        <FareCardHeader
          title={title || ""}
          subtitle={headline}
          description={description}
          hilighted={hilighted}
          hilightedLabel={hilighted ? t`Top Choice` : undefined}
        >
          {ctaButton && <React.Fragment>{ctaButton}</React.Fragment>}
        </FareCardHeader>
        <FareCardBaseContent padding="small">
          <FareCardInfographic
            cruiseGroup={undefined}
            enabledInclusions={enabledInclusions}
            fareCode={fareCode}
            inclusionsContentTokens={{}}
            expandable={false}
            isExpanded={false}
            disableInclusionDrawer
          />
        </FareCardBaseContent>
        {isBlockContentValuePresent(maybeFooterNotesForNonAirCountries) && (
          <MiniFareCardFooterDisclaimer>
            <BlockContent value={maybeFooterNotesForNonAirCountries} />
          </MiniFareCardFooterDisclaimer>
        )}
      </FareCardBase>
    </React.Fragment>
  );
};

export default MiniFareCard;
